import { FieldWidthEnum } from 'src/cer/cer-data/cer-data-types';
import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormView } from '@form/cer-form-view';

export class BankAccountForm extends CerFormAdapter {

  public override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'bank-konti', dataApiName: 'BankAccount', text: 'Konti', textSingular: 'Konto',
        primaryKey: 'id', titleFields: ['name'], baseFields: ['id','history']
      },
      fieldMetadata: [
        { name: 'name', text: 'Navn', tooltipText: 'Navn på konto', widthType: FieldWidthEnum.L },
        { fieldType: 'currencyId' },
        { name: 'ledgerAccount', text: 'Finanskontonr', foreignKeyTableName: 'FinanceLedgerAccount', foreignKeyField: 'num', foreignKeyValue: 'numName', foreignKeyColumns: ['num','name'], foreignKeyTitles: ['Konto','Navn'] },
        { name: 'bankIBAN', text: 'IBAN' },
        { name: 'bankRegNum', text: 'Bank regnr.' },
        { name: 'bankAccountNum', text: 'Bank kontonr.' },
        { name: 'active', text: 'Aktiv', format: 'CheckBox' },
        { name: 'openingBalanceCur', text: 'Opstart saldo', format: 'Amount' },
        { name: 'openingBalanceDate', text: 'Opstart dato', format: 'DateShort' }
      ]
    });
  }
}
